import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useField } from '@unform/core';
import { TextField, TextFieldProps } from '@material-ui/core';

const DataTimer: React.FC<TextFieldProps> = ({
  name,
  defaultValue,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const { fieldName, /* defaultValue, */ error, registerField } = useField(
    name == undefined ? '' : name,
  );

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  return (
    <TextField
      id="time"
      type="time"
      inputRef={inputRef}
      defaultValue={defaultValue}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export default DataTimer;
